import React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { basePath } from "./components/config";
import { useAuth } from "./contexts/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object({
  email: Yup.string().email().required("Required"),
  password: Yup.string().required("Required"),
});

const intialForm = {
  email: "",
  password: "",
};

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const Login = () => {
  const [{ activeUser }, { setActiveUser }] = useAuth();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: intialForm,
    validationSchema,
    onSubmit: (values) => {
      handaleLogin(values);
    },
  });
  console.log({ activeUser });
  async function handaleLogin(formData) {
    try {
      const data = await fetch(basePath + "login", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const res = await data.json();

      if (res.status) {
        const user = JSON.parse(res.user);
        setCookie(
          "user",
          JSON.stringify({ ...user, remember_token: JSON.parse(res.token) }),
          5
        );
        setActiveUser({ ...user, remember_token: JSON.parse(res.token) });
        toast.success(res.message);
        navigate("/order/1");
      } else {
        toast.error(res.message);
      }

      console.log(res);
    } catch (err) {
      toast.error("Error: " + err);
    }
  }

  return (
    <div className="h-full">
      <div className="g-6 flex h-full flex-wrap items-center justify-center lg:justify-between">
        <div className="shrink-1 mb-12 grow-0 basis-auto md:mb-0 md:w-9/12 md:shrink-0 lg:w-6/12 xl:w-6/12 flex justify-center items-center">
          <img
            src="https://tecdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
            className="w-3/4"
            alt="Sample image"
          />
        </div>

        <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">
          <form onSubmit={formik.handleSubmit}>
            <div className="flex flex-row items-center justify-center lg:justify-start">
              <p className="mb-3 mr-4 text-2xl ">Login</p>
            </div>

            <div className="relative mb-6" data-te-input-wrapper-init>
              <label className="block text-lg font-medium leading-6 text-gray-900 pt-4 pb-2">
                <span className="mb-2 inline-block"> Email address</span>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email..."
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  className="block w-[25vw] rounded-md border-2 py-1.5 px-2 text-black  sm:text-sm sm:leading-6 placeholder:text-gray-400"
                />
              </label>
              {formik.touched.email && formik.errors.email && (
                <div className="text-red-600 ">{formik.errors.email}</div>
              )}
            </div>

            <div className="relative mb-6" data-te-input-wrapper-init>
              <label className="block text-lg font-medium leading-6 text-gray-900 pt-4 pb-2">
                <span className="mb-2 inline-block">Password</span>
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Password..."
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  className="block w-[25vw] rounded-md border-2 py-1.5 px-2 text-black  sm:text-sm sm:leading-6 placeholder:text-gray-400"
                />
              </label>
              {formik.touched.password && formik.errors.password && (
                <div className="text-red-600 ">{formik.errors.password}</div>
              )}
            </div>

            <div className="text-center lg:text-left">
              <button
                type="submit"
                // disabled={formik.isSubmitting}
                className="text-white bg-orange py-2 px-4 rounded"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
